<template>
  <div>
    <!-- <el-row type="flex" justify="end" class="download">
      <span>下载报表</span>
    </el-row> -->
    <table class="gridtable" :style="{'color': textColor}">
      <tr>
        <template v-for="(item, index) in thList">
          <th :style="{'background-color': themeColor.color}" :key="index">{{item.label}}</th>
        </template>
      </tr>
      <template v-if="tableData.length>0">
        <template v-for="(tr,trIndex) in tableData">
          <tr :style="{'background': trIndex%2===1?themeColor.colorOpa:'transparent'}" :key="trIndex">
            <template v-for="(item, index) in thList">
              <td :key="index" v-if="index===0">{{trIndex+1}}</td>
              <td :key="index" v-else>{{tr[item.key]}}</td>
            </template>
          </tr>
          <template v-if="tr.cntAndDurationList&&tr.cntAndDurationList.length>0">
            <template v-for="(trChild) in tr.cntAndDurationList">
              <tr :key="trChild.type">
                <!-- <template v-for="(item, index) in tr.thList"> -->
                  <td ></td>
                  <td >{{trChild["type"]}}</td>
                <!-- </template> -->
              </tr>
            </template>
          </template>
        </template>
      </template>
    </table>
    <div class="empty" v-if="tableData.length===0">
      <p>暂无数据</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tableColumnsProps: {
      type: Array,
      default: () => []
    },
    tableDataProps: {
      type: Array,
      default: () => []
    },
    themeColor: {
      type: Object,
      default: () => {color:'#33CDCD';colorOpa: 'rgba(51, 205, 205, 0.05)'}
    },
    textColor: {
      type: String,
      default: () => '#333'
    }
  },
  watch: {
    tableDataProps: {
        handler(newValue) {
            if(newValue){
              // console.log(newValue)
                this.tableData = newValue;
            }
        },
        immediate: true,
        deep: true
    },
    tableColumnsProps: {
        handler(newValue) {
            if(newValue){
                this.thList = newValue;
            }
        },
        immediate: true,
        deep: true
    },
},
  data() {
    return {
      thList: [],
      tableData: []
    }
  }
}
</script>
<style lang='scss' scoped>
.download {
  span {
    display: inline-block;
    cursor: pointer;
    color: #5E5E5E;
    margin-bottom:3px;
  }
}
.empty {
  text-align: center;
  width: 100%;
  p{
    width: 100%;
    color: #999;
    margin-top: 20px
  }
}
//  表格排行榜css
table.gridtable {
  width: 100%;
  font-family: verdana,arial,sans-serif;
  font-size:11px;
  color:#333;
  border-collapse: collapse;
}
table.gridtable th {
  border-width: 1px;
  padding: 8px;
  text-align: center;
  color:#fff;
  // background-color: RGBA(51, 205, 205, 1);
}
table.gridtable td {
    border-width: 1px;
    padding: 8px;
    text-align: center;
    // color: #333;
}
.table-bg {
  background: rgba(0, 255, 255, 0.1)
}
 </style>